import { StatTableTimeColumn } from "components/StatsTable/Columns/Time/TimeColumn";
import { StatTableColumn } from "components/StatsTable/StatTableColumn";
import { SmsTimeAttackRecordWithDisplay } from "model/Records old/TimeAttackSmsRecord";
import { convertMsToTimeString } from "TimeHelper";

export const getSmsTimeAttackRecordTrackStatTableColumns = (
  roundHeaders: (string | undefined)[],
  trackIdx: number,
  bestTotal: number | undefined
): StatTableColumn<SmsTimeAttackRecordWithDisplay>[] => {
  return [
    {
      type: "Position",
      sortable: true,
      positionGetter: (arg) => arg.record.tracks[trackIdx]?.rank,
    },
    {
      type: "OrgLogoName",
      sortable: true,
      orgIdGetter: (arg) => arg.orgId,
      nameGetter: (arg) => arg.displayName,
      smallerSize: true,
    },
    {
      type: "Time",
      header: "Score",
      sortable: true,
      highlight: true,
      timeGetter: (arg) => arg.record.tracks[trackIdx].score,
      subTextGetter: (arg) => {
        const trackScore = arg.record.tracks[trackIdx].score;
        if (!!trackScore && !!bestTotal) {
          return `-${convertMsToTimeString(trackScore - bestTotal)}`;
        }
      },
    },
    ...roundHeaders.map((name, idx) => {
      const column: StatTableTimeColumn<SmsTimeAttackRecordWithDisplay> = {
        type: "Time",
        header: name ?? "",
        sortable: !!name,
        timeGetter: (arg) =>
          trackIdx >= 0
            ? arg.record.tracks[trackIdx]?.sortedTimes[idx]?.time
            : undefined,
        dnfAdjustedGetter: (arg) =>
          trackIdx >= 0
            ? arg.record.tracks[trackIdx]?.sortedTimes[idx]?.dnfAdjusted ??
              false
            : undefined,
      };

      return column;
    }),
  ];
};
